import axios from "axios";
import {API_URL, TOKEN} from "@/constants";
import {decryptData} from "@/utilities/crypto";

//export const TOKEN = "FUJI_ACCTG_TOKEN";
const instance = axios.create({
    baseURL: API_URL,
});

instance.interceptors.request.use((config) => {
    const CRED_TOKEN = decryptData(localStorage.getItem(TOKEN))
    let accessToken = CRED_TOKEN ?? null
    if (accessToken) {
        config.headers['Authorization'] = `Bearer ${accessToken}`;
    }
    return config
}, (error) => {
    return Promise.reject(error);
});

instance.interceptors.request.use((response) => {
    return Promise.resolve(response);
}, (error) => {
    return Promise.reject(error);
});

export { instance };
